import React from 'react';
import PropTypes from 'prop-types';
import Div from '@certilogo/design-system/dist/components/Div';

const Background = ({
  color = `linear-gradient(315deg, #7d55c7, #00b5e2 100%)`,
  style,
  ...rest
}) => <Div style={{ background: color, ...style }} {...rest} />;

Background.propTypes = {
  color: PropTypes.string,
  style: PropTypes.object,
};

export default Background;
